import React from 'react';
import { Icon } from '../../../../components';
import { SubmenuItem } from '../types/dropdownTypes';

interface SubmenuItemComponentProps {
  item: SubmenuItem;
  isActive: boolean;
  onClick: () => void;
}

export const SubmenuItemComponent: React.FC<SubmenuItemComponentProps> = ({
  item,
  isActive,
  onClick
}) => {
  const isEnabled = item.enabled !== false;

  return (
    <div
      className={`sidebar-submenu-item ${isActive ? 'active' : ''} ${!isEnabled ? 'disabled' : ''}`}
      onClick={isEnabled ? onClick : undefined}
    >
      <Icon icon={item.icon} size="sm" className="me-2" />
      {item.label}
    </div>
  );
};
